import { HorizontalSeparator } from '@uikit/components/HorizontalSeparator';

import { Typography } from '@ui/uikit/components/common/Typography';

interface InfoRowProps {
  title: string;
  details?: string | React.ReactNode;
  rightColContent?: string | React.ReactNode;
  dangerouslySetInnerHTML?: { __html: string };
}

const InfoRow = ({ title, details, rightColContent, dangerouslySetInnerHTML }: InfoRowProps) => (
  <>
    <div className="flex justify-between gap-1">
      <div className="flex flex-col gap-1 flex-1">
        <Typography variant="caption-m" color="tertiary">
          {title}
        </Typography>
        {details && (
          <Typography variant="caption-m" color="primary" data-qa="hot-offer-details">
            {details}
          </Typography>
        )}

        {dangerouslySetInnerHTML && (
          <h2
            className="text-neutral-600 leading-[1.7rem]"
            data-qa="hot-offer-details"
            dangerouslySetInnerHTML={dangerouslySetInnerHTML}
          />
        )}
      </div>

      {rightColContent && (
        <div className="flex flex-col justify-center align-middle">{rightColContent}</div>
      )}
    </div>
    <HorizontalSeparator lineClassName="!bg-neutral-100" />
  </>
);

export { InfoRow };
